import type { GradeStyleInput } from '@/components/features/grades/gradeStyle';

import GradeValuePill from '@/components/features/grades/GradeValuePill';

interface ParentGradeValueProps {
  grade: GradeStyleInput | null;
}

/**
 * The "Ocena" slot on a parent card.
 *
 * Always rendered, so an unmarked quiz or assignment reads as a grade that has
 * not been given yet rather than as a card that has no grade field at all.
 * Nothing resolves for a bare dash, so the pill falls back to its neutral
 * styling — the same component keeps both states from drifting apart.
 */
export function ParentGradeValue(parentGradeValueProps: ParentGradeValueProps) {
  const { grade } = parentGradeValueProps;

  return (
    <div className={'space-y-0.5'}>
      <p className={'text-muted-foreground text-xs'}>Ocena</p>
      <GradeValuePill grade={grade ?? { value: '-', valueType: null }} />
    </div>
  );
}
